import { render, staticRenderFns } from "./ListAlmacen.vue?vue&type=template&id=5b4ee810"
import script from "./ListAlmacen.vue?vue&type=script&lang=js"
export * from "./ListAlmacen.vue?vue&type=script&lang=js"
import style0 from "./ListAlmacen.vue?vue&type=style&index=0&id=5b4ee810&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports